import React from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Divider, Box, Avatar, Stack, IconButton } from '@mui/material';
import { deepPurple } from '@mui/material/colors';
import CloseIcon from '@mui/icons-material/Close';

const CategoryItemTypeDetails = ({ category_item_type, onClose }) => {
    if (!category_item_type)
        return <Typography variant="h6">Select a category item type to view details</Typography>;

    const tableHeaders = [
        { label: 'Field', width: '30%' },
        { label: 'Value', width: '70%' },
    ];

    const tableData = [
        { field: 'Τύπος Στοιχείου Κατηγορίας Περιγραφή', value: category_item_type?.pcit_descr },
        { field: 'Τύπος Στοιχείου Κατηγορίας AA', value: category_item_type?.pcit_aa },
    ];

    return (
        <Paper elevation={3} sx={{ padding: 2, borderRadius: 2, backgroundColor: '#f4f6f8', height: '100%' }}>
            <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
                <Stack direction="row" spacing={2} alignItems="center">
                    {/* TITLE ? */}
                </Stack>
                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </Stack>
            <Divider sx={{ marginBottom: 2 }} />
            <TableContainer component={Box}>
                <Table>
                    <TableBody>
                        {tableData.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell sx={{ color: '#757575', backgroundColor: index % 2 ? '#fafafa' : '#ffffff' }}>{row.field}</TableCell>
                                <TableCell sx={{ color: '#757575', backgroundColor: index % 2 ? '#fafafa' : '#ffffff' }}>{row.value}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};

export default CategoryItemTypeDetails;